import { convertReactAdminIdToHydraId } from 'utils';

export const getIdArrayFilterDefaultValue = (
  idArray: number[] | null,
  entity: string,
): string[] | [] => {
  return idArray ? idArray.map((id) => convertReactAdminIdToHydraId(id, entity)) : [];
};
